
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { redirectRules, findRedirect } from '@/lib/redirects';
import { handleSitemapRequest } from '@/middleware/sitemap-middleware';

interface RedirectMiddlewareProps {
  children: React.ReactNode;
}

export function RedirectMiddleware({ children }: RedirectMiddlewareProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  useEffect(() => {
    // Check if this is a sitemap request
    const isSitemapRequest = pathname.includes('/sitemap.xml') || pathname.includes('/sitemaps/');
    
    if (isSitemapRequest) {
      // Handle sitemap request - Note: This won't work in client-side rendering
      // but we still include the logic which will be used server-side eventually
      handleSitemapRequest(pathname)
        .then(response => {
          if (response) {
            console.log('Handled sitemap request:', pathname);
          }
        })
        .catch(err => {
          console.error('Error handling sitemap request:', err);
        });
      
      // Client-side we'll rely on the edge function instead
      return;
    }

    // Handle redirects
    const { redirectTo, isDynamic } = findRedirect(pathname);

    if (redirectTo) {
      // Handle different redirect types
      if (redirectTo === pathname) return; // avoid infinite loops
      
      // Use window.location for permanent redirects, navigate for temporary ones
      if (isDynamic) {
        navigate(redirectTo, { replace: true });
      } else {
        window.location.href = redirectTo;
      }
    }
  }, [pathname, navigate]);

  return <>{children}</>;
}
